export default import.meta.ROLLDOWN_FILE_URL_NCPjAHFNqcZ1i9R9trDlJA